// removed by extract-text-webpack-plugin
module.exports = {"content":"c-Summary__content","title":"c-Summary__title","receiptTitle":"c-Summary__receiptTitle","items":"c-Summary__items"};